import ky from 'ky'
import { redirectToCognitoPage } from './auth-api'

export const fetch = ky.extend({
  prefixUrl: `${process.env.REACT_APP_BASE_URL}/api`,
  throwHttpErrors: false,
  hooks: {
    beforeRequest: [
      request => {
        const token = localStorage.getItem('token')

        request.headers.set('X-Requested-With', 'ky');
        request.headers.set('Authorization', `Bearer ${token}`);
        request.headers.set('Content-Type', `application/json`);
      },
    ],
    afterResponse: [
      async (_, __, response) => {
        if (response.status === 401) {
          return redirectToCognitoPage()
        }

        if (response.status >= 400) {
          const data = await response.json()
          // The status is part of the answer, not noise. A 409 from the route-policy
          // endpoints means "someone else saved first", which the UI has to offer to
          // merge rather than report as a generic red toast — and that is impossible
          // once the only thing left of the response is a message string.
          const error = new Error(data.error || data)

          error.status = response.status

          throw error
        }

        return response;
      },
    ],
  },
})
